// extracted by mini-css-extract-plugin
export var backgroundColor = "#141821";
export var borderRadius = ".15rem";
export var maxModalWidth = "48em";
export var modalBackgroundColor = "rgba(20,24,33,.75)";
export var talkType = "talk-type-list-module--talk-type--cfa00";
export var talkTypeContainer = "talk-type-list-module--talk-type-container--4a703";
export var talkTypeInfo = "talk-type-list-module--talk-type-info--57d03";
export var talkTypesContainer = "talk-type-list-module--talk-types-container--25251";